import { HTTP } from '@/http-common'

function getDiscount (discountId) {
  return HTTP.get('/discounts/' + discountId)
}

function addDiscount (discountData) {
  let data = JSON.stringify(discountData)

  return HTTP.post('/discounts', data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

function updateDiscount (discountData) {
  let data = JSON.stringify(discountData)

  return HTTP.put('/discounts/' + discountData.id, data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

function deleteDiscount (discountId) {
  return HTTP.delete('/discounts/' + discountId)
}

export { getDiscount, addDiscount, updateDiscount, deleteDiscount }



// WEBPACK FOOTER //
// ./src/services/discount.service.js